/* Shopify Related candidates for Fashion/category "Worth a look" and store "Popular right now".
   Dedicated, diversified fallback rails never reuse the first 24 collection products.
   Recommendations use existing theme cards; the grid, filters and pagination stay native. */
(() => {
  'use strict';
  const selector = '[data-k-featured-recommendations]';
  function filteredView() {
    const url = new URL(window.location.href);
    return Array.from(url.searchParams.keys()).some(key =>
      key === 'page' || key === 'sort_by' || key.startsWith('filter.')
    );
  }
  async function loadSeed(section, seedId) {
    const url = new URL(section.dataset.kRecommendationsUrl, window.location.origin);
    url.searchParams.set('product_id', String(seedId));
    url.searchParams.set('section_id', 'kurlective-featured-recommendation-items');
    url.searchParams.set('limit', '10');
    url.searchParams.set('intent', 'related');
    const previewId = new URL(window.location.href).searchParams.get('preview_theme_id');
    if (previewId) url.searchParams.set('preview_theme_id', previewId);
    const response = await fetch(url.toString(), {credentials: 'same-origin'});
    if (!response.ok) throw new Error('recommendations unavailable');
    const html = new DOMParser().parseFromString(await response.text(), 'text/html');
    return Array.from(html.querySelectorAll('[data-k-recommendation-response] .k-recommendation-candidate'));
  }
  function isEligible(node, section, gridIds) {
    const d = node.dataset;
    if (!d.kProductId || gridIds.has(d.kProductId)) return false;
    const requiredCollection = section.dataset.kRequiredCollection;
    if (requiredCollection) {
      return (d.kCollectionHandles || '').includes('|' + requiredCollection + '|');
    }
    return d.kFashion === 'true' &&
      d.kProductType === section.dataset.kRequiredType &&
      ((section.dataset.kRequiredGender === 'women' && d.kWomen === 'true') ||
       (section.dataset.kRequiredGender === 'men' && d.kMen === 'true'));
  }
  async function init(section) {
    if (filteredView()) {
      // A filtered/sorted grid may overlap the fixed featured set; hide the rail.
      section.hidden = true;
      return;
    }
    const seedIds = [...new Set((section.dataset.kSeeds || '').split(',').filter(Boolean))];
    const rail = section.querySelector('[data-k-recommendations-rail]');
    if (!seedIds.length || !rail) return;
    const mainGrid = document.querySelector('.k-store-catalogue .product-grid');
    if (!mainGrid) return;
    const gridIds = new Set(Array.from(mainGrid.querySelectorAll('[data-product-id]'), el =>
      el.getAttribute('data-product-id')
    ).filter(Boolean));
    seedIds.forEach(id => gridIds.add(id));
    const resultSets = await Promise.allSettled(seedIds.map(id => loadSeed(section, id)));
    const candidates = [];
    for (let index = 0; index < 10; index += 1) {
      for (const group of resultSets) {
        if (group.status !== 'fulfilled') continue;
        if (group.value[index]) candidates.push(group.value[index]);
      }
    }
    const seen = new Set(gridIds), groups = new Map(), selected = [];
    const diversifyTypes = section.dataset.kDiversityMode === 'type';
    function takeCandidate(node, enforceDiversity) {
      const d = node.dataset;
      if (selected.length >= 6 || !isEligible(node, section, seen)) return;
      // A store is mostly a single vendor: spread across product types instead.
      const group = diversifyTypes ? (d.kProductType || '').trim().toLowerCase() : (d.kVendor || '').trim().toLowerCase();
      const count = groups.get(group) || 0;
      if (enforceDiversity && count >= 2) return;
      selected.push(node);
      seen.add(d.kProductId);
      groups.set(group, count + 1);
    }
    candidates.forEach(node => takeCandidate(node, true));
    candidates.forEach(node => takeCandidate(node, false));
    if (selected.length < 3 || filteredView()) return;
    const items = document.createDocumentFragment();
    for (const node of selected) {
      const item = document.createElement('div');
      item.className = 'k-store-popular__item';
      const card = node.querySelector('.k-store-product-card');
      if (card) {
        item.appendChild(card);
        items.appendChild(item);
      }
    }
    if (items.childElementCount < 3) return;
    rail.replaceChildren(items);
    const countEl = section.querySelector('.k-store-section-meta');
    if (countEl) countEl.textContent = String(rail.children.length) + ' ' +
      (section.dataset.kFeaturedCountLabel || 'featured products');
    section.hidden = false;
    const nav = document.querySelector('[data-k-recommendations-nav]');
    if (nav) nav.hidden = false;
    window.addEventListener('popstate', () => {
      if (filteredView()) {
        section.hidden = true;
        if (nav) nav.hidden = true;
      }
    });
  }
  function start() {
    document.querySelectorAll(selector).forEach(section => {
      if (section.dataset.kRecommendationsLoaded) return;
      section.dataset.kRecommendationsLoaded = 'true';
      init(section).catch(() => {});
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, {once:true});
  } else start();
})();
